import * as React from "react";
import TextField from "@material-ui/core/TextField/TextField";
import ChatLogo from "../../../../assets/chat_logo.svg";
import Button from "@material-ui/core/Button";
import Grid from "@material-ui/core/Grid";
import { withStyles } from "@material-ui/core";

const styles = () => ({
  chatbubbleWrapper: {
    overflow: "auto",
    display: "flex",
    margin: "4px",
  },
  chatBubble: {
    border: "1px solid #E7E7E7",
    borderRadius: "20px",
    margin: "0px 4px",
    width: "100%",
    maxWidth: 300,
    padding: 8,
  },
});

class ChatSubmit extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      topic: this.props.message.topic,
      description: this.props.message.description,
    };
  }
  render() {
    const {
      message,
      onClick,
      classes,
      submissionError,
      creatingTicket,
      createdTicket,
      errorMessage,
      theme
    } = this.props;

    return (
      <div container className={classes.chatbubbleWrapper}>
        <div style={{ display: "flex", alignItems: "center" }}>
          <img src={ChatLogo} alt="cy logo" />
        </div>
        <Grid container className={classes.chatBubble}>
          {/* leave this for future use */}
          {/* rihgt now we only allow for 1 topic */}
          {/* this is a drop down that allows for many help topics */}
          {/* <TextField
            value={this.state.topic}
            placeholder={this.state.topic}
            select
            SelectProps={{
              style: { marginTop: 0, textAlign: "left" },
            }}
            onChange={(e) => this.setState({ topic: e.target.value })}
            style={{ width: "100%" }}
          >
            <MenuItem disabled key="topic" value="">
              Topic
            </MenuItem>
            {message.options.map((option, index) => (
              <MenuItem key={`${option}${index}`} value={option}>
                {option}
              </MenuItem>
            ))}
          </TextField> */}

          <TextField
            disabled={creatingTicket || createdTicket || submissionError}
            value={this.state.description}
            label="Please describe your issue in a few lines."
            multiline
            rows={4}
            SelectProps={{
              style: { marginTop: 0 },
            }}
            onChange={(e) => this.setState({ description: e.target.value })}
            style={{ width: "100%" }}
          />
          <Button
            disabled={creatingTicket || createdTicket}
            style={{
              backgroundColor: theme.palette.primary.main,
              color: theme.palette.primary.contrastText,
              borderRadius: 20,
              marginTop: 4,
            }}
            onClick={(e) =>
              onClick(e, {
                ...message,
                // topic: this.state.topic,
                description: this.state.description,
              })
            }
          >
            {creatingTicket
              ? "Submitting your request"
              : createdTicket === null
              ? "Submit"
              : createdTicket && !submissionError
              ? "Your request has been submitted."
              : `Submission Error: ${errorMessage}. Please Email info@investwithcy.com`}
          </Button>
        </Grid>
      </div>
    );
  }
}
export default withStyles(styles, { withTheme: true })(ChatSubmit);



// WEBPACK FOOTER //
// ./src/components/HelpWidget/components/ChatSubmit/index.jsx